import type { UseMutationResult } from "@tanstack/react-query";

import { useMutation, useQueryClient } from "@tanstack/react-query";

import { toast } from "@/components/toast/toast-queue";
import apiClient from "@/lib/api/client";

interface ImpersonateResponse {
  JWT: string;
  message: string;
}

interface ImpersonateParams {
  targetUserCurrentProjectId?: null | number;
  targetUserId: number;
}

export function useImpersonate(): UseMutationResult<
  ImpersonateResponse,
  Error,
  ImpersonateParams
> {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({
      targetUserCurrentProjectId = null,
      targetUserId,
    }: ImpersonateParams) =>
      await apiClient
        .url("/auth/impersonate")
        .post({
          leaveImpersonationTo: window.location.href,
          targetUserCurrentProjectId,
          targetUserId,
        })
        .json<ImpersonateResponse>(),
    onError: (error) => {
      console.error("Error starting impersonation:", error);
      toast.add(
        { title: "Unable to impersonate this user", type: "error" },
        { timeout: 5000 },
      );
    },
    onSuccess: () => {
      queryClient.clear();
      window.location.href = "/requests";
    },
  });
}
